"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.initMergeSaga = initMergeSaga;
exports.mergeSaga = mergeSaga;
exports.testPort = void 0;
var sagaMiddlewareInstance;
var sagaToMerge = [];

function merge() {
  if (!sagaMiddlewareInstance) {
    return;
  }

  if (sagaToMerge.length) {
    sagaToMerge.forEach(function (saga) {
      sagaMiddlewareInstance.run(saga);
    });
    sagaToMerge.length = 0;
  }
}

function initMergeSaga(sagaMiddleware) {
  sagaMiddlewareInstance = sagaMiddleware;
  merge();
}

function mergeSaga(saga) {
  if (saga) {
    sagaToMerge.push(saga);
    merge();
  }
}

var testPort = {
  sagaToMerge: sagaToMerge
};
exports.testPort = testPort;